import { aligns } from 'components/library/Bookend';

export const bookendContent = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753460833/library/bookend/5f4e9939ee3b96921d9af4d502cbdd3edf2a3d2a.jpg',
    alt: 'Bookend cover',
    width: 1312,
    height: 1208,
  },
  title: 'Seed',
  word: 'Labs',
  body: 'Because health is not just human.',
  eyebrow: '● Lipari, Panarea — Italy',
  primaryButton: {
    label: 'Read More',
    url: '/seedlabs',
  },
  align: 'center' as aligns,
};

const bookendContentTwo = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753995020/library/bookend/force-life.png',
    alt: 'Bookend cover',
    width: 1312,
    height: 1208,
  },
  title: 'Change your gut health for good.*',
  titleStyle: {
    fontWeight: '350',
    fontSize: 'var(--font-size-600)',
    lineHeight: '28px',
    color: 'var(--text-inverse-primary)',
    marginTop: '-32px',
  },
  body: 'Feel lasting relief in one week with DS-01®*',
  primaryButton: {
    label: 'Shop Now',
    url: '/daily-synbiotic',
    color: 'snowwhite',
  },
  align: 'center' as aligns,
  additionalImage: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752512630/library/bookend/image_164.png',
    alt: 'Additional image',
    width: 232,
    height: 142,
  },
};

export const bookendContentStory = {
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887588/library/bookend/cover-2.jpg',
    alt: 'Bookend cover',
    width: 1312,
    height: 1208,
  },
  pill: 'DS-01®',
  eyebrow: '● Lipari, Panarea — Italy',
  title: 'Change your gut health for good.',
  body: 'Feel lasting relief in one week with DS-01®*',
  primaryButton: {
    label: 'Read More',
    url: '#',
  },
};

// Original bookendItems (Center aligned)
export const bookendItems = [bookendContent, bookendContentTwo];

// Top aligned bookendItems
export const bookendItemsTop = [
  {
    ...bookendContent,
    align: 'start' as aligns,
  },
  {
    ...bookendContentTwo,
    align: 'start' as aligns,
  },
];

// Center aligned bookendItems (default)
export const bookendItemsCenter = [
  {
    ...bookendContent,
    align: 'center' as aligns,
  },
  {
    ...bookendContentTwo,
    align: 'center' as aligns,
  },
];

// Center aligned bookendItems with Pills
export const bookendItemsCenterWithPill = [
  {
    ...bookendContent,
    pill: 'DS-01®',
    align: 'center' as aligns,
  },
  {
    ...bookendContentTwo,
    pill: 'PDS-08®',
    align: 'center' as aligns,
  },
];

// Center aligned bookendItems with Eyebrows
export const bookendItemsCenterWithEyebrow = [
  {
    ...bookendContent,
    eyebrow: '● Lipari, Panarea — Italy',
    align: 'center' as aligns,
  },
  {
    ...bookendContentTwo,
    eyebrow: '● Science & Research',
    align: 'center' as aligns,
  },
];

// Bottom aligned bookendItems
export const bookendItemsBottom = [
  {
    ...bookendContent,
    align: 'end' as aligns,
  },
  {
    ...bookendContentTwo,
    align: 'end' as aligns,
  },
];

// Bottom aligned bookendItems with Eyebrows
export const bookendItemsBottomWithEyebrow = [
  {
    ...bookendContent,
    eyebrow: '● Lipari, Panarea — Italy',
    align: 'end' as aligns,
  },
  {
    ...bookendContentTwo,
    eyebrow: '● Science & Research',
    align: 'end' as aligns,
  },
];
